import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';

import { gql } from '@apollo/client';
import _ from 'lodash';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import ShootsOverviewRow from '../../components/shootsOverviewRow';
import constants from '../../../utils/constants';
import '../../../assets/scss/heatmaps-shoots-overview.scss';
import moment from 'moment';
import ShowShootOverviewDetails from '../../components/modals/projects/showShootOverviewDetails';
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
const getShootsCalendar = gql`
	query EventsCalendar($filters: EventCalendarFiltersInput) {
		eventsCalendar(filters: $filters) {
			workspaces {
				_id
				workspaceId
				workspaceKey
			}
			eventCategories {
				category
				count
			}
			events {
				date
				count
			}

			eventsMonthly {
				city
				count
				month
				workspaceId
			}
		}
	}
`;
const getVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput, $vendorId: String!) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				projectSlNo
				slNo
				category
				crew {
					count
					role
					managerIds
					subRole
					userIds
					__typename
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				time
				outStation
				flagLabel
				reportingTime
				durationInHrs
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				projectTitle
				parentEventName
				childEvents {
					_id
					expenses {
						_id
						amount
						billTo
						billDate
						currency
						__typename
					}
					name
					parentEvent_id
					__typename
				}
				memoryCards {
					status
					isReceived
					__typename
				}
				equipments {
					isReceived
					status
					__typename
				}
				additionalServices {
					type
					_id
					__typename
				}
				__typename
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
			__typename
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			associatedTenants {
				_id
				workspaceId
				workspaceKey
				__typename
			}
			isSuperHuemn
			__typename
		}
		vendorUsers {
			isShooter
			isSuspended
			lastName
			isEmailVerified
			firstName
			id
			displayName
			phoneNumber
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
		}
	}
`;
class ShootsOverview extends ProjectsGraphQl {
	constructor() {
		super();
		const getDateRangeData = (isStart = true) => {
			let startFinancialYear = moment().quarter() > 1 ? moment().year() : moment().year() - 1;
			let endFinancialYear = moment().quarter() > 1 ? moment().year() + 1 : moment().year();

			if (isStart === true) {
				return parseInt(`${startFinancialYear}0401`);
			} else {
				return parseInt(`${endFinancialYear}0331`);
			}
		};

		const getYearFilterOptions = () => {
			let startDate = getDateRangeData(true);
			let endDate = getDateRangeData(false);

			let diff = moment(`${startDate}`, 'YYYYMMDD').year() - 2018; //show options till financial year 2018
			let dateFilterOptions = [];
			for (let i = 0; i <= diff; i++) {
				dateFilterOptions.push({
					name: `${Math.floor(startDate / 10000) - i} - ${
						Math.floor(endDate / 10000) - i
					}`,
					key: `${Math.floor(startDate / 10000) - i}${`${startDate}`.slice(4)},${
						Math.floor(endDate / 10000) - i
					}${`${endDate}`.slice(4)}`,
				});
			}

			return dateFilterOptions;
		};
		this.state = {
			isLoading: true,
			workspaceList: [],
			workspaceActiveFilter: [],
			workspaceFilterCleared: false,
			heatMapToggle: true,
			revcolActiveFilter: 'no',
			revcolor: false,
			categoriesActiveFilter: '',
			dateRangeActiveFilter: '20230401,20240331',
			shootsActiveFilter: '',
			limit: 100,
			isLoading: true,
			eventsCalendar: [],
			dateString: null,
			// startDate: null,
			// endDate: null,
			shootList: [],
			datesArray: [],
			showEventModal: false,
			statusFilters: [
				{ key: 'upcoming', name: 'Upcoming Shoots' },
				{ key: 'today', name: 'Today' },
				{ key: 'completed', name: 'Completed Shoots' },
			],

			isPageLoading: true,
			abscityActiveFilter: 'yes',
			showModal: false,
			isHeatMapLoading: true,
			isWorkspaceLoading: true,
			heatMapToggle: true,
			heatMapData: [],
			workspaceList: [],
			tenantIdsActiveFilter: [],
			startDate: getDateRangeData(true),
			endDate: getDateRangeData(false),
			monthsList: [
				'apr',
				'may',
				'jun',
				'jul',
				'aug',
				'sep',
				'oct',
				'nov',
				'dec',
				'jan',
				'feb',
				'mar',
			],
			monthsListMap: new Map([
				['04', 'apr'],
				['05', 'may'],
				['06', 'jun'],
				['07', 'jul'],
				['08', 'aug'],
				['09', 'sep'],
				['10', 'oct'],
				['11', 'nov'],
				['12', 'dec'],
				['01', 'jan'],
				['02', 'feb'],
				['03', 'mar'],
			]),
			monthsListMapToNum: new Map([
				['04', 0],
				['05', 1],
				['06', 2],
				['07', 3],
				['08', 4],
				['09', 5],
				['10', 6],
				['11', 7],
				['12', 8],
				['01', 9],
				['02', 10],
				['03', 11],
			]),
			cities: ['HYD', 'BLR', 'DEL', 'CHE', 'IN', ''],
			cityMap: {
				hyderabad: 'HYD',
				banglore: 'BLR',
				delhi: 'DEL',
				chennai: 'CHE',
				india: 'IN',
				null: '',
			},
			cityMapNew: new Map([
				['hyderabad', 'HYD'],
				['banglore', 'BLR'],
				['delhi', 'DEL'],
				['chennai', 'CHE'],
				['india', 'IN'],
				[null, ''],
			]),
			cityMapToNum: new Map([
				['hyderabad', 0],
				['banglore', 1],
				['delhi', 2],
				['chennai', 3],
				['india', 4],
				[null, 5],
			]),
			cityHeatMap: {
				heatMap: [],
				absoluteMax: 0,
				rowWiseMax: [0, 0, 0, 0, 0, 0], //1st HYD, 2nd BLR, 3rd DEL, 4th CHE
				columnWiseMax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //1st apr, 2nd may and so on
			},
			workspaceHeatmap: [],
			dateFilterOptions: getYearFilterOptions(),
			categoriesFilters: [
				{ name: 'Engagement', key: 'engagement' },
				{ name: 'Pellikuthuru', key: 'pellikuthuru' },
				{ name: 'Pellikoduku', key: 'pellikoduku' },
				{ name: 'Sangeeth', key: 'sangeeth' },
				{ name: 'Mehendi', key: 'mehendi' },
				{ name: 'Couple Shoot', key: 'coupleshoot' },
				{ name: 'Haldi', key: 'haldi' },
				{ name: 'Wedding', key: 'wedding' },
				{ name: 'Reception', key: 'reception' },
				{ name: 'Cocktail', key: 'cocktail' },
				{ name: 'Rituals', key: 'rituals' },
				{ name: 'Baraat', key: 'baraat' },
				{ name: 'Birthday', key: 'birthday' },
				{ name: 'Baby Shower', key: 'babyshower' },
				{ name: 'Pre-Wedding Rituals', key: 'preweddingrituals' },
				{ name: 'Others', key: 'others' },
			],
		};
		this.workspaceDropDownRef = React.createRef();
		this.workspacewrapper = React.createRef();
	}

	getActiveWorkspaceFilter = () => {
		// If user has selected specific workspaces, use those
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			return this.state.workspaceActiveFilter;
		}
		// If user explicitly cleared the workspace filter, return null to fetch all data
		if (this.state.workspaceFilterCleared) return null;
		// Otherwise use vendor's activeWorkspaces from constants (extract _id)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			return vendorConfig.activeWorkspaces.map(w => w._id);
		}
		return null;
	};

	componentDidMount = async () => {
		// Pre-select active workspaces from constants (extract _id for filter keys)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			this.setState({ workspaceActiveFilter: vendorConfig.activeWorkspaces.map(w => w._id) });
		}

		await this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];

		if (_.size(urlSearch) > 0) {
			let count = 0;
			let tempCount = 0;
			let searchType = null;
			let tempUrlSearch = _.cloneDeep(urlSearch);
			while (tempCount < _.size(tempUrlSearch)) {
				let subString = tempUrlSearch[tempCount].split('=');

				tempCount++;
			}
			json = {
				filters: {},
			};
			let startDateString = '';
			let endDateString = '';
			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0]) {
					let activeDate = '';
					if (subString[0] === 'startDate' || subString[0] === 'endDate') {
						json = {
							filters: { ...json.filters, [subString[0]]: parseInt(subString[1]) },
						};
						this.setState({
							[subString[0]]: subString[1],
						});
						if (subString[0] === 'startDate') {
							startDateString = subString[1];
						}
						if (subString[0] === 'endDate') {
							endDateString = subString[1];
						}
					} else if (
						subString[0] !== 'shoots' &&
						subString[0] !== 'startDate' &&
						subString[0] !== 'endDate' &&
						subString[0] !== 'absCity' &&
						subString[0] !== 'revcolor'
					) {
						json = {
							filters: {
								...json.filters,

								[`${subString[0] === 'categories' ? 'category' : subString[0]}`]:
									subString[0] === 'categories'
										? subString[1]
										: subString[1].split(','),
							},
						};

						this.setState({
							[`${
								subString[0] === 'tenantIds'
									? 'workspaceActiveFilter'
									: `${subString[0]}ActiveFilter`
							}`]:
								subString[0] === 'subFilter'
									? subString[1]
									: subString[1].split(','),
						});
					} else if (
						subString[0] === 'shoots' &&
						subString[0] !== 'startDate' &&
						subString[0] !== 'endDate' &&
						subString[0] !== 'absCity' &&
						subString[0] !== 'revcolor'
					) {
						json = {
							filters: {
								...json.filters,
								['subFilter']: subString[1],
							},
						};

						this.setState({
							shootsActiveFilter: subString[1],
						});
					} else if (subString[0] === 'absCity') {
						this.setState({
							abscityActiveFilter: subString[1],
							heatMapToggle: subString[1] === 'yes' ? true : false,
						});
					}
					if (subString[0] === 'revcolor') {
						this.setState({
							revcolActiveFilter: subString[1],
							revcolor: subString[1] === 'yes' ? true : false,
						});
					}
				}

				count++;
			}

			this.setState({
				dateRangeActiveFilter: `${startDateString},${endDateString}`,
			});

			await this.getShootsCalendar(getShootsCalendar, json);
		} else {
			await this.getShootsCalendar(getShootsCalendar);
		}
		// if(this.state.startDate && this.state.endDate){
		// 	let newJson = {
		// 		filters: {
		// 			page: 1,
		// 			limit: this.state.limit,
		// 			endDate: this.state.endDate,
		// 			startDate:this.state.startDate

		// 		},
		// 		vendorId: this.props.params.vendorID,
		// 	};
		// 	await this.getVendorEventsList(getVendorEventsList, newJson);
		// }
	};
	renderProposalsHeatMap = (cityHeatMap, workspaceHeatmap, type) => {
		const sortedCityData2 = this.state.allCityData.slice().sort((a, b) => b - a);
		const uniqueValues2 = [...new Set(sortedCityData2)];
		const medianIndex2 = Math.floor(uniqueValues2.length / 2);
		const maxMonthCount2 = uniqueValues2[0];
		const minMonthCount2 = uniqueValues2[uniqueValues2.length - 1];
		return (
			<div className="phm-tables-container">
				<table className="phm-heat-map-table">
					<thead>
						<tr>
							<th colSpan={14}>Absolute distribution</th>
						</tr>
						<tr>
							<th className="normal-span five-px-border-right"></th>
							<th className="normal-span five-px-border-right">Total</th>
							{_.map(this.state.monthsList, (month, inx) => {
								return (
									<th
										className={
											'normal-span' +
											((inx + 1) % 3 === 0 &&
											inx !== _.size(this.state.monthsList) - 1
												? ' five-px-border-right'
												: '')
										}
									>
										{month.toUpperCase()}
									</th>
								);
							})}
						</tr>
					</thead>
					<tbody>
						{_.map(cityHeatMap.heatMap, (cityData, inx) => {
							return (
								<>
									<tr>
										<th className="five-px-border-right">
											{this.state.cities[inx]}
										</th>
										<td className="five-px-border-right">{_.sum(cityData)}</td>
										{_.map(cityData, (monthCount, i) => {
											let opacity;
											const uniqueIndex = uniqueValues2.indexOf(monthCount);

											if (uniqueIndex >= 0 && uniqueIndex <= medianIndex2) {
												opacity = 1 - uniqueIndex / medianIndex2;
											} else if (
												uniqueIndex > medianIndex2 &&
												uniqueIndex < uniqueValues2.length
											) {
												opacity =
													(uniqueIndex - medianIndex2) /
													(uniqueValues2.length - medianIndex2);
											} else {
												opacity = 0;
											}

											const topColor = `rgba(45, 86, 57, ${opacity})`;
											const bottomColor = `rgba(86, 26, 11, ${opacity})`;
											const backgroundColor =
												uniqueIndex >= 0 && uniqueIndex <= medianIndex2
													? topColor
													: bottomColor;

											const tdStyle = {
												backgroundColor: backgroundColor,
											};

											return (
												<td
													className={
														(i + 1) % 3 === 0 &&
														i !== _.size(cityData) - 1
															? ' five-px-border-right'
															: ''
													}
													style={tdStyle}
												>
													{monthCount === 0 ? '\u00b7' : monthCount}
												</td>
											);
										})}
									</tr>
								</>
							);
						})}
						<tr>
							<td colSpan={14} className="full-span"></td>
						</tr>
						{this.state.heatMapToggle ? (
							<>
								{_.map(workspaceHeatmap, (workspace, index) => {
									const sortedCityData = this.state.allBrandCounts[index]
										.slice()
										.sort((a, b) => b - a);
									const uniqueValues = [...new Set(sortedCityData)];
									const medianIndex = Math.floor(uniqueValues.length / 2);
									const maxMonthCount = uniqueValues[0];
									const minMonthCount = uniqueValues[uniqueValues.length - 1];
									return _.map(workspace.heatMap, (workspaceHeatData, inx) => {
										return (
											<>
												<tr
													className={
														inx === _.size(workspace.heatMap) - 1
															? ' five-px-border'
															: ''
													}
												>
													<th className="five-px-border-right">
														{
															_.find(this.state.workspaceList, {
																workspaceId:
																	workspace.workspaces[inx],
															})?.workspaceKey
														}
													</th>
													<td className="five-px-border-right ">
														{_.sum(workspaceHeatData)}
													</td>

													{_.map(workspaceHeatData, (monthCount, i) => {
														let opacity;
														const uniqueIndex =
															uniqueValues.indexOf(monthCount);

														if (
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
														) {
															opacity = 1 - uniqueIndex / medianIndex;
														} else if (
															uniqueIndex > medianIndex &&
															uniqueIndex < uniqueValues.length
														) {
															opacity =
																(uniqueIndex - medianIndex) /
																(uniqueValues.length -
																	1 -
																	medianIndex);
														} else {
															opacity = 0;
														}

														const topColor = `rgba(45, 86, 57, ${opacity})`;
														const bottomColor = `rgba(86, 26, 11, ${opacity})`;
														const backgroundColor =
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
																? topColor
																: bottomColor;

														const tdStyle = {
															backgroundColor: backgroundColor,
														};

														return (
															<td
																className={
																	(i + 1) % 3 === 0 &&
																	i !==
																		_.size(workspaceHeatData) -
																			1
																		? ' five-px-border-right CellWithComment'
																		: 'CellWithComment'
																}
																style={tdStyle}
															>
																{monthCount === 0
																	? '\u00b7'
																	: monthCount}
																<span class="CellComment">
																	<p>
																		{_.find(
																			this.state
																				.workspaceList,
																			{
																				workspaceId:
																					workspace
																						.workspaces[
																						inx
																					],
																			},
																		)?.workspaceKey + '  '}
																		<span
																			style={{
																				textTransform:
																					'capitalize',
																			}}
																		>
																			{
																				this.state
																					.monthsList[i]
																			}
																		</span>
																	</p>
																</span>
															</td>
														);
													})}
												</tr>
											</>
										);
									});
								})}
							</>
						) : (
							<>
								{_.map(workspaceHeatmap, (workspace, index) => {
									return _.map(workspace.heatMap, (workspaceHeatData, inx) => {
										const sortedCityData = this.state.allCityMonthCounts
											.slice()
											.sort((a, b) => b - a);
										const uniqueValues = [...new Set(sortedCityData)];
										const medianIndex = Math.floor(uniqueValues.length / 2);
										const maxMonthCount = uniqueValues[0];
										const minMonthCount = uniqueValues[uniqueValues.length - 1];
										return (
											<>
												<tr
													className={
														inx === _.size(workspace.heatMap) - 1
															? ' five-px-border'
															: ''
													}
												>
													<th className="five-px-border-right">
														{
															_.find(this.state.workspaceList, {
																workspaceId:
																	workspace.workspaces[inx],
															})?.workspaceKey
														}
													</th>
													<td className="five-px-border-right ">
														{_.sum(workspaceHeatData)}
													</td>

													{_.map(workspaceHeatData, (monthCount, i) => {
														let opacity;
														const uniqueIndex =
															uniqueValues.indexOf(monthCount);

														if (
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
														) {
															opacity = 1 - uniqueIndex / medianIndex;
														} else if (
															uniqueIndex > medianIndex &&
															uniqueIndex < uniqueValues.length
														) {
															opacity =
																(uniqueIndex - medianIndex) /
																(uniqueValues.length -
																	1 -
																	medianIndex);
														} else {
															opacity = 0;
														}

														const topColor = `rgba(45, 86, 57, ${opacity})`;
														const bottomColor = `rgba(86, 26, 11, ${opacity})`;
														const backgroundColor =
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
																? topColor
																: bottomColor;

														const tdStyle = {
															backgroundColor: backgroundColor,
														};

														return (
															<td
																className={
																	(i + 1) % 3 === 0 &&
																	i !==
																		_.size(workspaceHeatData) -
																			1
																		? ' five-px-border-right CellWithComment'
																		: 'CellWithComment'
																}
																style={tdStyle}
															>
																{monthCount === 0
																	? '\u00b7'
																	: monthCount}
																<span class="CellComment">
																	<p>
																		{_.find(
																			this.state
																				.workspaceList,
																			{
																				workspaceId:
																					workspace
																						.workspaces[
																						inx
																					],
																			},
																		)?.workspaceKey + '  '}
																		<span
																			style={{
																				textTransform:
																					'capitalize',
																			}}
																		>
																			{
																				this.state
																					.monthsList[i]
																			}
																		</span>
																	</p>
																</span>
															</td>
														);
													})}
												</tr>
											</>
										);
									});
								})}
							</>
						)}
					</tbody>
				</table>
				<table className="phm-heat-map-table">
					<thead>
						<tr>
							<th colSpan={12}>Column wise % Distribution</th>
						</tr>
						<tr>
							{_.map(this.state.monthsList, (month, inx) => {
								return (
									<th
										className={
											'normal-span' +
											((inx + 1) % 3 === 0 &&
											inx !== _.size(this.state.monthsList) - 1
												? ' five-px-border-right'
												: '')
										}
									>
										{month.toUpperCase()}
									</th>
								);
							})}
						</tr>
					</thead>
					<tbody>
						{_.map(cityHeatMap.heatMap, (cityData, inx) => {
							return (
								<>
									<tr>
										{_.map(cityData, (monthCount, i) => {
											const sortedCityData = this.state.resCityColData[i]
												.slice()
												.sort((a, b) => b - a);
											const uniqueValues = [...new Set(sortedCityData)];
											const medianIndex = Math.floor(uniqueValues.length / 2);
											const maxMonthCount = uniqueValues[0];
											const minMonthCount =
												uniqueValues[uniqueValues.length - 1];
											let opacity;
											const uniqueIndex = uniqueValues.indexOf(monthCount);

											if (uniqueIndex >= 0 && uniqueIndex <= medianIndex) {
												opacity = 1 - uniqueIndex / medianIndex;
											} else if (
												uniqueIndex > medianIndex &&
												uniqueIndex < uniqueValues.length
											) {
												opacity =
													(uniqueIndex - medianIndex) /
													(uniqueValues.length - medianIndex - 1);
											} else {
												opacity = 0;
											}

											const topColor = `rgba(45, 86, 57, ${opacity})`;
											const bottomColor = `rgba(86, 26, 11, ${opacity})`;
											const backgroundColor =
												uniqueIndex >= 0 && uniqueIndex <= medianIndex
													? topColor
													: bottomColor;

											const tdStyle = {
												backgroundColor: backgroundColor,
											};
											return (
												<td
													className={
														(i + 1) % 3 === 0 &&
														i !== _.size(cityData) - 1
															? ' five-px-border-right'
															: ''
													}
													style={tdStyle}
												>
													{monthCount === 0 ? '\u00b7' : monthCount}
												</td>
											);
										})}
									</tr>
								</>
							);
						})}
						<tr>
							<td colSpan={12} className="full-span"></td>
						</tr>
						{this.state.heatMapToggle ? (
							<>
								{_.map(workspaceHeatmap, (workspace, index) => {
									return _.map(workspace.heatMap, (workspaceHeatData, inx) => {
										return (
											<>
												<tr
													className={
														inx === _.size(workspace.heatMap) - 1
															? ' five-px-border'
															: ''
													}
												>
													{_.map(workspaceHeatData, (monthCount, i) => {
														const sortedCityData =
															this.state.resColData[index][i]
																.slice()
																.sort((a, b) => b - a);
														const uniqueValues = [
															...new Set(sortedCityData),
														];
														const medianIndex = Math.floor(
															uniqueValues.length / 2,
														);
														const maxMonthCount = uniqueValues[0];
														const minMonthCount =
															uniqueValues[uniqueValues.length - 1];
														let opacity;
														const uniqueIndex =
															uniqueValues.indexOf(monthCount);

														if (
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
														) {
															opacity = 1 - uniqueIndex / medianIndex;
														} else if (
															uniqueIndex > medianIndex &&
															uniqueIndex < uniqueValues.length
														) {
															opacity =
																(uniqueIndex - medianIndex) /
																(uniqueValues.length -
																	medianIndex -
																	1);
														} else {
															opacity = 0;
														}

														const topColor = `rgba(45, 86, 57, ${opacity})`;
														const bottomColor = `rgba(86, 26, 11, ${opacity})`;
														const backgroundColor =
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
																? topColor
																: bottomColor;

														const tdStyle = {
															backgroundColor: backgroundColor,
														};
														return (
															<td
																className={
																	(i + 1) % 3 === 0 &&
																	i !==
																		_.size(workspaceHeatData) -
																			1
																		? ' five-px-border-right CellWithComment'
																		: 'CellWithComment'
																}
																style={tdStyle}
															>
																{monthCount === 0
																	? '\u00b7'
																	: monthCount}
																<span class="CellComment">
																	<p>
																		{_.find(
																			this.state
																				.workspaceList,
																			{
																				workspaceId:
																					workspace
																						.workspaces[
																						inx
																					],
																			},
																		)?.workspaceKey + '  '}
																		<span
																			style={{
																				textTransform:
																					'capitalize',
																			}}
																		>
																			{
																				this.state
																					.monthsList[i]
																			}
																		</span>
																	</p>
																</span>
															</td>
														);
													})}
												</tr>
											</>
										);
									});
								})}
							</>
						) : (
							<>
								{_.map(workspaceHeatmap, (workspace, index) => {
									return _.map(workspace.heatMap, (workspaceHeatData, inx) => {
										return (
											<>
												<tr
													className={
														inx === _.size(workspace.heatMap) - 1
															? ' five-px-border'
															: ''
													}
												>
													{_.map(workspaceHeatData, (monthCount, i) => {
														const sortedCityData =
															this.state.mergedData[i]
																.slice()
																.sort((a, b) => b - a);
														const uniqueValues = [
															...new Set(sortedCityData),
														];
														const medianIndex = Math.floor(
															uniqueValues.length / 2,
														);
														const maxMonthCount = uniqueValues[0];
														const minMonthCount =
															uniqueValues[uniqueValues.length - 1];
														let opacity;
														const uniqueIndex =
															uniqueValues.indexOf(monthCount);

														if (
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
														) {
															opacity = 1 - uniqueIndex / medianIndex;
														} else if (
															uniqueIndex > medianIndex &&
															uniqueIndex < uniqueValues.length
														) {
															opacity =
																(uniqueIndex - medianIndex) /
																(uniqueValues.length -
																	medianIndex -
																	1);
														} else {
															opacity = 0;
														}

														const topColor = `rgba(45, 86, 57, ${opacity})`;
														const bottomColor = `rgba(86, 26, 11, ${opacity})`;
														const backgroundColor =
															uniqueIndex >= 0 &&
															uniqueIndex <= medianIndex
																? topColor
																: bottomColor;

														const tdStyle = {
															backgroundColor: backgroundColor,
														};
														return (
															<td
																className={
																	(i + 1) % 3 === 0 &&
																	i !==
																		_.size(workspaceHeatData) -
																			1
																		? ' five-px-border-right CellWithComment'
																		: 'CellWithComment'
																}
																style={tdStyle}
															>
																{monthCount === 0
																	? '\u00b7'
																	: monthCount}
																<span class="CellComment">
																	<p>
																		{_.find(
																			this.state
																				.workspaceList,
																			{
																				workspaceId:
																					workspace
																						.workspaces[
																						inx
																					],
																			},
																		)?.workspaceKey + '  '}
																		<span
																			style={{
																				textTransform:
																					'capitalize',
																			}}
																		>
																			{
																				this.state
																					.monthsList[i]
																			}
																		</span>
																	</p>
																</span>
															</td>
														);
													})}
												</tr>
											</>
										);
									});
								})}
							</>
						)}
					</tbody>
				</table>
				<table className="phm-heat-map-table">
					<thead>
						<tr>
							<th colSpan={14}>Row wise % Distribution</th>
						</tr>
						<tr>
							{_.map(this.state.monthsList, (month, inx) => {
								return (
									<th
										className={
											'normal-span' +
											((inx + 1) % 3 === 0 &&
											inx !== _.size(this.state.monthsList) - 1
												? ' five-px-border-right'
												: '')
										}
									>
										{month.toUpperCase()}
									</th>
								);
							})}
							<th
								className={'normal-span' + ' five-px-border-right'}
								style={{
									borderLeft: '10px solid #121212',
								}}
							>
								Total
							</th>
							<th className="normal-span five-px-border-right"></th>
						</tr>
					</thead>
					<tbody>
						{_.map(cityHeatMap.heatMap, (cityData, inx) => {
							const sortedCityData = cityData.slice().sort((a, b) => b - a);
							const uniqueValues = [...new Set(sortedCityData)];
							const medianIndex = Math.floor(uniqueValues.length / 2);
							const maxMonthCount = uniqueValues[0];
							const minMonthCount = uniqueValues[uniqueValues.length - 1];

							return (
								<>
									<tr>
										{_.map(cityData, (monthCount, i) => {
											let opacity;
											const uniqueIndex = uniqueValues.indexOf(monthCount);

											if (uniqueIndex >= 0 && uniqueIndex <= medianIndex) {
												opacity = 1 - uniqueIndex / medianIndex;
											} else if (
												uniqueIndex > medianIndex &&
												uniqueIndex < uniqueValues.length
											) {
												opacity =
													(uniqueIndex - medianIndex) /
													(uniqueValues.length - 1 - medianIndex);
											} else {
												opacity = 0;
											}

											const topColor = `rgba(45, 86, 57, ${opacity})`;
											const bottomColor = `rgba(86, 26, 11, ${opacity})`;
											const backgroundColor =
												uniqueIndex >= 0 && uniqueIndex <= medianIndex
													? topColor
													: bottomColor;

											const tdStyle = {
												backgroundColor: backgroundColor,
											};
											return (
												<td
													className={
														(i + 1) % 3 === 0 &&
														i !== _.size(cityData) - 1
															? ' five-px-border-right'
															: ''
													}
													style={tdStyle}
												>
													{monthCount === 0 ? '\u00b7' : monthCount}
												</td>
											);
										})}
										<td
											className="five-px-border-right"
											style={{
												borderLeft: '10px solid #121212',
											}}
										>
											{_.sum(cityData)}
										</td>
										<th className="five-px-border-right">
											{this.state.cities[inx]}
										</th>
									</tr>
								</>
							);
						})}
						<tr>
							<td colSpan={14} className="full-span"></td>
						</tr>
						{_.map(workspaceHeatmap, (workspace, index) => {
							return _.map(workspace.heatMap, (workspaceHeatData, inx) => {
								const sortedCityData = workspaceHeatData
									.slice()
									.sort((a, b) => b - a);
								const uniqueValues = [...new Set(sortedCityData)];
								const medianIndex = Math.floor(uniqueValues.length / 2);
								const maxMonthCount = uniqueValues[0];
								const minMonthCount = uniqueValues[uniqueValues.length - 1];
								return (
									<>
										<tr
											className={
												inx === _.size(workspace.heatMap) - 1
													? ' five-px-border'
													: ''
											}
										>
											{_.map(workspaceHeatData, (monthCount, i) => {
												let opacity;
												const uniqueIndex =
													uniqueValues.indexOf(monthCount);

												if (
													uniqueIndex >= 0 &&
													uniqueIndex <= medianIndex
												) {
													opacity = 1 - uniqueIndex / medianIndex;
												} else if (
													uniqueIndex > medianIndex &&
													uniqueIndex < uniqueValues.length
												) {
													opacity =
														(uniqueIndex - medianIndex) /
														(uniqueValues.length - 1 - medianIndex);
												} else {
													opacity = 0;
												}

												const topColor = `rgba(45, 86, 57, ${opacity})`;
												const bottomColor = `rgba(86, 26, 11, ${opacity})`;
												const backgroundColor =
													uniqueIndex >= 0 && uniqueIndex <= medianIndex
														? topColor
														: bottomColor;

												const tdStyle = {
													backgroundColor: backgroundColor,
												};
												return (
													<td
														className={
															(i + 1) % 3 === 0 &&
															i !== _.size(workspaceHeatData) - 1
																? ' five-px-border-right CellWithComment'
																: 'CellWithComment'
														}
														style={tdStyle}
													>
														{monthCount === 0 ? '\u00b7' : monthCount}
														<span class="CellComment">
															<p>
																{_.find(this.state.workspaceList, {
																	workspaceId:
																		workspace.workspaces[inx],
																})?.workspaceKey + '  '}
																<span
																	style={{
																		textTransform: 'capitalize',
																	}}
																>
																	{this.state.monthsList[i]}
																</span>
															</p>
														</span>
													</td>
												);
											})}
											<td
												className="five-px-border-right "
												style={{
													borderLeft: '10px solid #121212',
												}}
											>
												{_.sum(workspaceHeatData)}
											</td>
											<th className="five-px-border-right">
												{
													_.find(this.state.workspaceList, {
														workspaceId: workspace.workspaces[inx],
													})?.workspaceKey
												}
											</th>
										</tr>
									</>
								);
							});
						})}
					</tbody>
				</table>
			</div>
		);
	};
	onDayClick = (month, day) => {
		let datestring = moment(
			month + `-${day + 1 < 10 ? `0${day + 1}` : day + 1}`,
			'YYYY-MM-DD',
		).format('YYYYMMDD');

		this.setState({
			selectedDate: datestring,
			showEventModal: true,
		});
	};
	toggleModal = () => {
		this.setState({
			showEventModal: !this.state.showEventModal,
		});
	};
	renderTableBody = () => {
		var startDate = moment(moment(this.state.startDate, 'YYYYMMDD').format('YYYY-MM-DD'));

		var endDate = moment(moment(this.state.endDate, 'YYYYMMDD').format('YYYY-MM-DD'));
		var betweenMonths = [];

		if (startDate < endDate) {
			var date = startDate.startOf('month');

			while (date < endDate.endOf('month')) {
				betweenMonths.push(date.format('YYYY-MM'));
				date.add(1, 'month');
			}
		}

		return _.map(betweenMonths, (shoot, index) => {
			return (
				<ShootsOverviewRow
					onDayClick={(month, day) => {
						this.onDayClick(month, day);
					}}
					month={shoot}
					data={this.state.eventsCalendar}
					maxCount={_.maxBy(this.state.eventsCalendar, 'count').count}
				/>
			);
		});
	};

	handleclearSelection2 = (e, type) => {
		if (type === 'dateRange') {
			this.setState(
				{
					startDate: this.state.dateFilterOptions[0].key.split(',')[0],
					endDate: this.state.dateFilterOptions[0].key.split(',')[1],
					dateRangeActiveFilter: this.state.dateFilterOptions[0].key,
					isPageLoading: true,
					// dateRangeActiveFilter: key
				},
				() => this.fetchFilteredEvents(),
			);
		} else {
			this.setState(
				{
					[`${type}ActiveFilter`]: '',
				},
				() => this.fetchFilteredEvents(),
			);
		}
	};

	handleActiveFilter = (e, type, key) => {
		console.log(key);
		let array;

		array = [...this.state[`${type}ActiveFilter`]];
		if (type == 'revcol') {
			if (key === 'yes') {
				this.setState(
					{
						revcolor: true,
						revcolActiveFilter: 'yes',
					},

					() => this.fetchFilteredEvents(),
				);
			} else if (key === 'no') {
				this.setState(
					{
						// revcolor: this.state.abscityActiveFilter === 'no' ? true : false,
						revcolor: false,
						// abscityActiveFilter: this.state.abscityActiveFilter === 'no' ? 'yes' : 'no',
						revcolActiveFilter: 'no',
					},
					() => this.fetchFilteredEvents(),
					// () => this.fetchMoreGraphData(),
				);
			}
		} else if (type === 'abscity') {
			if (key === 'yes') {
				this.setState(
					{
						heatMapToggle: true,
						abscityActiveFilter: 'yes',
					},
					() => this.fetchFilteredEvents(),
				);
			} else if (key === 'no') {
				this.setState(
					{
						heatMapToggle: this.state.abscityActiveFilter === 'no' ? true : false,
						abscityActiveFilter: this.state.abscityActiveFilter === 'no' ? 'yes' : 'no',
					},
					() => this.fetchFilteredEvents(),
				);
			}
		} else {
			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}

			this.setState(
				{
					[`${type}ActiveFilter`]: array,

					isPageLoading: true,
				},
				() => this.fetchFilteredEvents(),
			);
		}
	};
	handleActiveFilter2 = (e, type, key) => {
		if (type === 'dateRange') {
			if (this.state.dateRangeActiveFilter === key) {
				this.setState(
					{
						startDate: this.state.dateFilterOptions[0].key.split(',')[0],
						endDate: this.state.dateFilterOptions[0].key.split(',')[1],
						dateRangeActiveFilter: this.state.dateFilterOptions[0].key,
						isPageLoading: true,
					},
					() => this.fetchFilteredEvents(),
				);
			} else {
				this.setState(
					{
						startDate: key.split(',')[0],
						endDate: key.split(',')[1],
						dateRangeActiveFilter: key,
						isPageLoading: true,
					},
					() => this.fetchFilteredEvents(),
				);
			}
		} else {
			this.setState(
				{
					[`${type}ActiveFilter`]: key,

					isPageLoading: true,
				},
				() => this.fetchFilteredEvents(),
			);
		}
	};
	fetchFilteredEvents = async () => {
		const wsFilter = this.getActiveWorkspaceFilter();
		let queryString = `?`;
		let urlSearch =
			window.location.search.split('?') && _.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];

		queryString = `?startDate=${this.state.startDate}&endDate=${this.state.endDate}&absCity=${this.state.abscityActiveFilter}&absCity=${this.state.abscityActiveFilter}&revcolor=${this.state.revcolActiveFilter}`;
		//Condition for workspace
		if (wsFilter)
			queryString = `${queryString}${
				_.size(urlSearch) > 0 && urlSearch[0] === 'category' ? '&' : ''
			}tenantIds=${wsFilter.toString()}`;

		//Condition for shooters filter
		if (_.size(this.state.categoriesActiveFilter) > 0) {
			queryString = `${queryString}${
				_.size(urlSearch) > 0 ? '&' : ''
			}categories=${this.state.categoriesActiveFilter.toString()}`;
		}
		if (this.state.shootsActiveFilter !== '') {
			queryString = `${queryString}${
				_.size(urlSearch) > 0 ? '&' : ''
			}shoots=${this.state.shootsActiveFilter.toString()}`;
		}

		this.props.navigate(`/${this.props.params.vendorID}/shoots-overview${queryString}`);
		let eventsListJson = {
			filters: {
				startDate: parseInt(this.state.startDate),
				endDate: parseInt(this.state.endDate),
			},
		};
		if (_.size(this.state.categoriesActiveFilter) > 0) {
			eventsListJson.filters.category = this.state.categoriesActiveFilter;
		}

		//Condition for Workspace
		if (wsFilter)
			eventsListJson.filters.tenantIds = wsFilter;
		//Condition for shootsActiveFilter
		if (this.state.shootsActiveFilter !== '') {
			eventsListJson.filters.subFilter = this.state.shootsActiveFilter;
		}

		this.getShootsCalendar(getShootsCalendar, eventsListJson);
	};

	applyFilter = (filter, type) => {
		if (type === 'dateRange') {
			if (this.state.dateRangeActiveFilter === filter) {
				this.setState(
					{
						startDate: this.state.dateFilterOptions[0].filter.split(',')[0],
						endDate: this.state.dateFilterOptions[0].filter.split(',')[1],
						dateRangeActiveFilter: this.state.dateFilterOptions[0].filter,
						isPageLoading: true,
					},
					() => this.fetchFilteredEvents(),
				);
			} else {
				this.setState(
					{
						startDate: filter.split(',')[0],
						endDate: filter.split(',')[1],
						dateRangeActiveFilter: filter,
						isPageLoading: true,
					},
					() => this.fetchFilteredEvents(),
				);
			}
		} else {
			this.setState(
				{
					[`${type}ActiveFilter`]: filter,
					isPageLoading: true,
					...(type === 'workspace' ? { workspaceFilterCleared: false } : {}),
				},
				() => {
					this.fetchFilteredEvents();
				},
			);
		}
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: type === 'shoots' || type === 'categories' ? '' : [],
				isPageLoading: true,
				...(type === 'workspace' ? { workspaceFilterCleared: true } : {}),
			},
			() => {
				this.fetchFilteredEvents();
			},
		);
	};

	render() {
		return (
			<div className="layout-wrapper">
				{' '}
				{this.state.isLoading === true ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<Filter
									type={'dateRange'}
									label={'Year'}
									version="v2"
									filters={this.state.dateFilterOptions}
									activeFilter={this.state.dateRangeActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter2(e, 'dateRange', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection2(e, 'dateRange')
									}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'workspace', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'categories'}
									label={'Event'}
									version="v2"
									filters={this.state.categoriesFilters}
									activeFilter={this.state.categoriesActiveFilter}
									handleActiveFilter={(e, type, key) => {
										this.handleActiveFilter(e, 'categories', key);
									}}
									clearSelection={(e) => {
										this.handleclearSelection(e, 'categories');
									}}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'shoots'}
									version="v2"
									label={'Dates'}
									filters={this.state.statusFilters}
									activeFilter={this.state.shootsActiveFilter}
									handleActiveFilter={(e, type, key) => {
										this.handleActiveFilter2(e, 'shoots', key);
									}}
									clearSelection={(e) => {
										this.handleclearSelection2(e, 'shoots');
									}}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
							</div>
							<div
								className="filters"
								style={{
									padding: '0px',
									top: '15px',
									right: '24px',
									width: 'fit-content',
									zIndex: '55',
								}}
							>
								<div className="filtersv2-container">
									<p className="filter-text">Group by city</p>
									<div className="toggle-container">
										<div
											className="filter-styles"
											style={{
												backgroundColor:
													this.state.heatMapToggle === true &&
													this.state.abscityActiveFilter === 'yes'
														? '#5437A1'
														: '#2F2F2F',
												color:
													this.state.heatMapToggle === true &&
													this.state.abscityActiveFilter === 'yes'
														? '#F5F5F5'
														: '#707070',
												borderRadius: '12px 0 0 12px',
											}}
											onClick={(e) => {
												this.handleActiveFilter(e, 'abscity', 'yes');
											}}
										>
											Yes
										</div>
										<div
											className="filter-styles"
											style={{
												backgroundColor:
													this.state.heatMapToggle === true &&
													this.state.abscityActiveFilter === 'yes'
														? '#2F2F2F'
														: '#5437A1',
												color:
													this.state.heatMapToggle === true &&
													this.state.abscityActiveFilter === 'yes'
														? '#707070'
														: '#F5F5F5',

												borderRadius: '0 12px 12px 0 ',
											}}
											onClick={(e) => {
												this.handleActiveFilter(e, 'abscity', 'no');
											}}
										>
											No
										</div>
									</div>
								</div>
							</div>
						</div>
						{this.state.isPageLoading === true ? (
							<LoadingBar />
						) : (
							<>
								<div
									className="phm-outermost-container"
									style={{
										marginTop: '80px',
									}}
								>
									<div className="phm-tables-outer-container">
										{this.renderProposalsHeatMap(
											this.state.cityHeatMap,
											this.state.workspaceHeatmap,
											'sent',
										)}
									</div>
								</div>
								<div
									className={'table shoots-table'}
									style={{
										paddingBottom: '100px',
									}}
								>
									<div className="projects-table-outer-container">
										<table className="shootTable eventscalendar-table">
											<thead>
												<tr>
													<th className="all-other-column-fixed">
														<div className="th-header">
															<p className="header-title">Date</p>
														</div>
													</th>
													<th className="all-other-column-fixed ">
														<div className="th-header text-center">
															<p className="header-title text-center">
																TOTAL
															</p>
														</div>
													</th>
													{[...Array(31)].map((e, i) => (
														<th
															className="all-other-column-fixed "
															width={40}
														>
															<div className="th-header text-center">
																<p className="header-title text-center">
																	{i + 1}
																</p>
															</div>
														</th>
													))}
												</tr>
											</thead>
											<tbody>{this.renderTableBody()}</tbody>
										</table>
									</div>
								</div>
							</>
						)}
						{/* TEST */}
						<ShowShootOverviewDetails
							custClass={'modal-with-no-fixed-height'}
							workspacesFilters={this.state.workspacesFilters}
							handleClose={() => this.toggleModal()}
							show={this.state.showEventModal}
							// eventDate={this.props.onDayClick}
							eventDate={this.state.selectedDate}
							vendorID={this.props.params.vendorID}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(ShootsOverview);
